import { useMutation } from '@tanstack/react-query';
import { appAPI } from '../../utils/api';
import urls from '../../utils/urls';
import { onRefreshCapabilityDiscovery } from './cacheKeys';

export type InitiateRefreshCapabilityDiscoveryRequest = {
    medicalProfileId: string;
    endpointId: number;
};

export type UseInitiateRefreshCapabilityDiscoveryReturnValue = {
    initiateRefreshCapabilityDiscovery: (args: InitiateRefreshCapabilityDiscoveryRequest) => void;
};

export default function useInitiateRefreshCapabilityDiscovery(): UseInitiateRefreshCapabilityDiscoveryReturnValue {
    const initiateRefreshCapabilityDiscovery = useMutation({
        mutationFn: (args: InitiateRefreshCapabilityDiscoveryRequest) => {
            return appAPI.post(
                urls.api.ehrIntegrations.oneUpHealth.endpoints.refreshCapabilityDiscovery(
                    args.medicalProfileId,
                    String(args.endpointId),
                ),
            );
        },
        onError: () => {
            // do nothing, this just fires in the background
        },
        onSuccess: (_data, args) => {
            onRefreshCapabilityDiscovery.resetCache({
                medicalProfileId: args.medicalProfileId,
                endpointId: args.endpointId,
            })();
        },
    });

    return {
        initiateRefreshCapabilityDiscovery: initiateRefreshCapabilityDiscovery.mutate,
    };
}
